exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer[data-v-4b315264] {\n  background-color: #ffffff;\n  border-top: 1px solid rgba(120, 130, 140, 0.13);\n  color: #67757c;\n  padding: 0.8rem 0.8rem;\n  width: 100%;\n  height: 100%;\n}\na[data-v-4b315264] {\n  color: #67757c;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b315264","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/TermsFooter.vue
// module id = sM5H
// module chunks = 1